import { useDispatch, useSelector } from 'react-redux';
import { getTaskAggregateEffect } from 'store/effects/taskAggregate';
import {
  getTaskFilters,
  getTransactionsTasksFilterSelector,
} from 'store/selectors/transactionTasks';
import { getUserId } from 'store/selectors/user';
import { prepareFiltersWithTransactionTask } from '../components/Tasks/components/Actions/Filter/FilterSections/helper';

export const useFetchAggregateTasks = () => {
  const dispatch = useDispatch();

  const { transactionsTasksFilter } = useSelector(getTransactionsTasksFilterSelector);
  const taskFilters = useSelector(getTaskFilters);
  const loggedInUserID = useSelector(getUserId);

  const refetchAggregateTasks = (otherFilters = {}, cb?) => {
    dispatch(
      getTaskAggregateEffect(
        {
          ...otherFilters,
          filters: prepareFiltersWithTransactionTask(
            transactionsTasksFilter,
            loggedInUserID,
            taskFilters,
          ),
        },
        { silent: true },
        cb,
      ),
    );
  };

  return { refetchAggregateTasks };
};
